import http from '@/http';
import requestUrlFunction from '@/utils/requestUrl';

export default {
  namespaced: true,
  actions: {
    async searchPrinters(context, params) {
      const response = await http.get(`printer/${requestUrlFunction(params)}`);

      return response;
    },
    async updatePrinter(context, printer) {
      const response = await http.put(`printer/${printer.serialNumber}`, {
        code: printer.code,
        creditSystemLock: printer.creditSystemLock,
      });

      return response;
    },
    async getPrinter(context, serialNumber) {
      const response = await http.get(`printer/${serialNumber}`);

      return response;
    },
    async deletePrinter(context, serialNumber) {
      const response = await http.delete(`printer/${serialNumber}`);

      return response;
    },
    async getPrinterCounters(context, serialNumber) {
      const response = await http.get(`printer/${serialNumber}/counters`);

      return response;
    },
    async updatePrinterCounter(context, { serialNumber, code, hidden }) {
      const response = await http.put(`printer/${serialNumber}/counters/${encodeURIComponent(code)}`, { hidden });

      return response;
    },
    async updatePrinterToner(context, { serialNumber, data }) {
      const response = await http.post(`printer/${serialNumber}/toner`, data);

      return response;
    },
  },
};
